import { Injectable } from '@angular/core';
import * as moment from 'moment';

declare var $;

@Injectable()
export class Global {

    config;
    usuario;
    VERSION = 1.10;


    constructor() { }

    async get_config() {

        this.config = await this.readJson('config');

    }

    async apiCall(url, method, auth = false, data = null) {

        if (!this.config) this.config = await this.readJson('config');

        let headers = {
            "Content-Type": "application/json",
            "X-Requested-With": "XMLHttpRequest"
        };

        if (auth) {

            let token = JSON.parse(localStorage.getItem('ERSM_TOKEN'));

            if (!token) return;

            let access_token = token.access_token;

            headers['Authorization'] = "Bearer " + access_token;

        }

        let settings = {
            url: this.config.api + url,
            method: method,
            headers: headers,
            timeout: 45000
        };

        if (data) {

            settings['data'] = JSON.stringify(data)

        }

        let result;

        try{
            result = await $.ajax(settings);
        } catch(e) {
            return {status: false};
        }
        return result;

    }

    async readJson(JSON) {

        let headers = {
            "Content-Type": "application/json"
        };

        let settings = {
            cache: false,
            url: "assets/json/" + JSON + ".json",
            method: 'GET',
            headers: headers
        };

        return await $.ajax(settings);

    }

    async checkVersion() {

        let apiVersion = await this.apiCall('version?app=DOCUMENTACIONSINIESTROS', 'GET', false);

        if (apiVersion != this.VERSION) location.reload();

    }

}
